<!-- 上传 -->
<template>
  <div id='uploadPage'>
    <app-title>反馈给未来魔法校</app-title>
    <div class="wrap">
      <div class="left" id="uploadfile" :class="{'disabled': disabled}">
        <img src="/img/cloud.png" alt="cloud" class="cloud">
        <input type="file" id="uploadInput" class="input-file" @change="doUpload" :disabled="disabled" :class="{'disabled':disabled}">
        <p>点击上传文件</p>
        <span>支持上传视频/ppt/图片/ Excel/word/压缩包文件
        </span>
      </div>
      <div class="right">
        <app-progress v-for="(item, index) in uploadList" :key="index" :file="item" @delete="$emit('delete', true)"></app-progress>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/server'
import { getObjectURL, RndNumber, getFileSuffix } from '@/utils'
// import Base64 from '../../../public/js/base64.js'
import '../../../public/js/crypto1//crypto/crypto'
import '../../../public/js/crypto1/hmac/hmac'
import '../../../public/js/crypto1/sha1/sha1'
export default {
  data () {
    return {
      url: '',
      filters: {
        type: Object,
        default () {
          return {
            ext: 'jpg,gif,jpeg,png,bmp',
            max_file_size: '5mb'
          }
        }
      },
      gDirname: '',
      gObjectName: '',
      policyText: '',
      policyBase64: '',
      message: '',
      bytes: '',
      signature: '',
      file: {},
      loading: {}
    }
  },
  props: {
    uploadList: Array,
    disabled: Boolean
  },
  components: {},
  watch: {
    uploadList: {
      handler () {
        this.uploadList.forEach(v => {
          v.progress = 1
        })
      }
    },
    deep: true,
    immediate: true
  },
  methods: {
    beforeAvatarUpload (file) {
      const isLt4G = file.size / 1024 / 1024 / 1024 < 4
      if (!isLt4G) {
        this.$message.error('上传图片大小不能超过 4GB!')
      }
      return isLt4G
    },
    // 上传到服务器,普通方式
    doUpload (e) {
      this.file = e.target.files[0]
      var OSS = require('ali-oss')
      if (this.beforeAvatarUpload(this.file)) {
        this.imgUrl = getObjectURL(this.file)
        let params = {
          'type': 'campsite'
        }
        api.queryOSS(params).then(res => {
          this.access = res.data
          var client = new OSS({
            accessKeyId: this.access.access_key_id,
            accessKeySecret: this.access.access_key_secret,
            stsToken: this.access.security_token,
            endpoint: this.access.endpoint,
            bucket: this.access.bucket
          })
          this.uploadList.push({
            name: this.file.name.split('.')[0],
            suffix: '.' + this.file.name.split('.')[1],
            progress: 0,
            size: this.file.size
          })
          var storeAs = this.access.prefix + this.file.name.split('.')[0] + new Date().getTime() + RndNumber(5) + `.${this.file.name.split('.')[1]}`
          // this.url = storeAs
          let tempCheckpoint
          var progress = (p, checkpoint) => {
            this.uploadList[this.uploadList.length - 1] && (this.uploadList[this.uploadList.length - 1].progress = p)
            tempCheckpoint = checkpoint
            return function (done) {
              done()
            }
          }
          this.loading = this.$loading({
            lock: true,
            text: '上传中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.3)'
          })
          client.multipartUpload(storeAs, this.file, {
            progress: progress,
            checkpoint: tempCheckpoint,
            headers: {
              'Content-Disposition': 'attachment'
            }
          }).then(res => {
            if (res.res.status === 200) {
              this.loading.close()
              let params = {
                size: this.file.size,
                name: this.file.name,
                material_type: this.$route.query.type,
                school_id: this.$route.query.id,
                grade: this.$route.query.id,
                content: 'http://' + this.access.bucket + '.' + this.access.endpoint + '/' + res.name,
                suffix: '.' + getFileSuffix(this.file.name)
              }
              params.name.indexOf('.') !== -1 && (params.name = params.name.split('.')[0])
              api.feedbackUpload(params).then(res => {
                let fileinput = document.getElementById('uploadInput')
                fileinput.value = ''
                if (res.ok) {
                  this.$emit('upload', true)
                } else {
                }
              })
            } else {
              this.loading.close()
            }
          }).catch(function (err) {
            console.log(err)
          })
        })
      }
    }
  },
  destroyed () {
    this.loading.close && this.loading.close()
  }
}
</script>
<style scoped lang='scss'>
#uploadPage {
  .wrap {
    display: flex;
    justify-content: space-between;
  }
  .left {
    margin-left: 20px;
    display: inline-block;
    width: 240px;
    height: 240px;
    border: 1px dashed rgba(188, 195, 201, 1);
    border-radius: 8px;
    background: #fff;
    position: relative;
    margin-top: 20px;
    &.disabled {
      opacity: 0.7;
    }
    .cloud {
      width: 54px;
      height: 40px;
      margin: 66px auto 20px;
    }
    .input-file {
      opacity: 0;
      width: 240px;
      height: 240px;
      cursor: pointer;
      position: absolute;
      top: 0;
      left: 0;
      &.disabled {
        cursor: not-allowed !important;
      }
    }
    p {
      font-size: 14px;
    }
    span {
      display: inline-block;
      width: 132px;
      margin-top: 8px;
      color: #666;
      font-size: 12px;
    }
  }
  .right {
    width: 510px;
    display: inline-block;
    margin-right: 26px;
    margin-top: 20px;
  }
}
</style>
